import { useMemo, useState } from 'react'
import { Box, Breadcrumbs, Typography, Stack, Chip, IconButton } from '@mui/material'
import { History } from '@mui/icons-material'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import { listLots, type Lot } from '../../api/stocuri'
import LotHistoryDialog from './LotHistoryDialog'

export default function LotsPage() {
  const [historyTarget, setHistoryTarget] = useState<Lot | null>(null)
  const { data, isLoading } = useQuery({ queryKey: ['stocuri', 'loturi'], queryFn: listLots })

  const columns = useMemo<GridColDef<Lot>[]>(() => [
    { field: 'lotNumber', headerName: 'Lot', width: 150, renderCell: (p) => <code>{p.row.lotNumber}</code> },
    { field: 'articleCode', headerName: 'Cod', width: 130 },
    { field: 'articleDescription', headerName: 'Articol', flex: 1, minWidth: 180 },
    { field: 'expiryDate', headerName: 'Valabil până la', width: 140, valueGetter: (v: string | null) => v ?? '' },
    {
      field: 'isExpired', headerName: '', width: 110, sortable: false,
      renderCell: (p) => p.row.isExpired ? <Chip size="small" label="Expirat" color="error" /> : null,
    },
    { field: 'totalQuantity', headerName: 'Total', width: 100, type: 'number', valueFormatter: (v: number) => v.toFixed(3).replace('.', ',') },
    { field: 'liberQuantity', headerName: 'Liber', width: 100, type: 'number', valueFormatter: (v: number) => v.toFixed(3).replace('.', ',') },
    {
      field: 'actions', headerName: '', width: 56, sortable: false, filterable: false, disableColumnMenu: true,
      renderCell: (p) => <IconButton size="small" onClick={() => setHistoryTarget(p.row)}><History fontSize="small" /></IconButton>,
    },
  ], [])

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">Stocuri</Typography>
        <Typography variant="inherit" color="text.primary">Loturi și trasabilitate</Typography>
      </Breadcrumbs>
      <Typography variant="h2">Loturi și trasabilitate</Typography>
      <Box sx={{ height: 560, bgcolor: 'background.paper', borderRadius: 1.5 }}>
        <DataGrid rows={data ?? []} columns={columns} loading={isLoading} density="comfortable" disableRowSelectionOnClick
          getRowId={(r) => `${r.articleId}-${r.lotNumber}`}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} pageSizeOptions={[25, 50]} />
      </Box>

      <LotHistoryDialog lot={historyTarget} onClose={() => setHistoryTarget(null)} />
    </Stack>
  )
}
